import { createAsyncThunk } from '@reduxjs/toolkit';

import { JsonQuery, type TJsonQuery, getGeoValueByType } from '@/packages/JsonQuery';
import { isNonEmptyArray } from '@/packages/JsonQuery/utils/isNonEmptyArray';
import { type IJsonQueryDistrict } from '@/packages/api-models/common/json_query';

import { type TThunkApi } from '@/microfrontends/filters/shared/store';
import { type ISimpleGeoTag } from '@/microfrontends/filters/shared/types/geoTags';

import { updateMeta } from './updateMeta';

interface ISelectDistrictResult {
  jsonQuery: TJsonQuery;
  geoTagsDistricts: ISimpleGeoTag[];
}

export const selectDistrict = createAsyncThunk<ISelectDistrictResult, ISimpleGeoTag<'district'>, TThunkApi>(
  'districtsPopup/selectDistrict',
  async (district, thunkApi) => {
    const { getState, dispatch } = thunkApi;
    const state = getState();

    const prevJsonQuery = state.districtsPopup.jsonQuery;
    const nextJsonQuery = new JsonQuery(prevJsonQuery);
    const jqDistrict: IJsonQueryDistrict = { id: district.id, type: 'district' };

    const districtsPrev: IJsonQueryDistrict[] = getGeoValueByType<IJsonQueryDistrict>('district')(prevJsonQuery) || [];
    const districtsNext: IJsonQueryDistrict[] = [...districtsPrev, jqDistrict];
    const geoTagsDistrictsNext = [...state.districtsPopup.geoTags.district];
    const hasDistrictTag = !!geoTagsDistrictsNext.find(({ id }) => district.id === id);

    if (!hasDistrictTag) {
      geoTagsDistrictsNext.push({
        type: 'district',
        id: district.id,
        name: district.name,
      });
    }

    if (isNonEmptyArray(districtsNext)) {
      nextJsonQuery.setDistricts(...districtsNext);
    }

    const nextJsonQuerySerialized = nextJsonQuery.toJSON();

    // специально не блокируемся об получение мета
    dispatch(updateMeta(nextJsonQuerySerialized));

    return {
      geoTagsDistricts: geoTagsDistrictsNext,
      jsonQuery: nextJsonQuerySerialized,
    };
  },
);
